import { Box, Button, FormControl, FormLabel, MenuItem, Select, Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { Route, Routes, useNavigate } from "react-router-dom";
import { ProductData, TemplateData } from "../../types";
import { CopyIcon } from "../../assets/svgs/CopyIcon";
import { AddTemplate } from "./AddTemplate";
import { CloneTemplate } from "./CloneTemplate";
import { EditTemplate } from "./EditTemplate";
import { PlusIcon } from "../../assets/svgs/PlusIcon";
import { TemplateThumbnail } from "./TemplateThumbnail";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { ScheduleTemplate } from "./ScheduleTemplate";
import { ArrowDropDown } from "@mui/icons-material";
import { ArrowDownIcon } from "../../assets/svgs/ArrowDownIcon";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";

export const Templates = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState<ProductData[]>([]);
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [templates, setTemplates] = useState<TemplateData[]>([]);

  const refetchProducts = async () => {
    const {errors, data} = await fetchData('/products/all');
    setProducts(data ?? []);
  }

  const refetchTemplates = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/templates/all');
    setTemplates(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchProducts();
      refetchTemplates();
    }
  }, [isAuthenticated]);

  const onAddPage = () => {
    navigate('/templates/create');
  }

  return (
    <Frame title="Engagement Pages" toolbarButtons={(
      <>
        <Button variant="contained" onClick={onAddPage} startIcon={<CopyIcon color="#FFFFFF" />}>
          Create Page
        </Button>
      </>
    )}>
      <Stack>
        <Routes>
          <Route
            path="/create/"
            element={<AddTemplate refetchTemplates={refetchTemplates} products={products} />}
          ></Route>
          <Route
            path="/:template_id/clone"
            element={<CloneTemplate refetchTemplates={refetchTemplates} products={products} />}
          ></Route>
          <Route
            path="/:template_id/schedule"
            element={<ScheduleTemplate />}
          ></Route>
          <Route
            path="/:template_id/"
            element={<EditTemplate refetchTemplates={refetchTemplates} products={products} />}
          ></Route>
        </Routes>
        <Stack spacing={4}>
          <Box>
            <Stack direction='row' spacing={4} alignItems='center' sx={{ cursor: 'pointer' }} mb={2}>
              {/* <Typography sx={{ color: '#040505', fontSize: 18, fontWeight: '600' }}>Glenfidich 12yr</Typography>
              <ArrowDownIcon color="#003317" /> */}
            </Stack>
            <Grid2 container spacing={4}>
              {
                templates.map((item: TemplateData, index: number) => (
                  <Grid2 xs={12} sm={6} md={3} lg={3} xl={2} key={index}>
                    <TemplateThumbnail template={item} key={index} />
                  </Grid2>
                ))
              }
            </Grid2>
          </Box>
          {/* <Box>
            <Stack direction='row' spacing={4} alignItems='center' sx={{ cursor: 'pointer' }} mb={2}>
              <Typography sx={{ color: '#040505', fontSize: 18, fontWeight: '600' }}>Glenfidich 18yr</Typography>
              <ArrowDownIcon color="#003317" />
            </Stack>
            <Grid2 container spacing={4}>
              {
                templates.map((item: TemplateData, index: number) => (
                  <Grid2 xs={12} sm={6} md={3} lg={3} xl={2} key={index}>
                    <TemplateThumbnail template={item} key={index} />
                  </Grid2>
                ))
              }
            </Grid2>
          </Box> */}
        </Stack>
      </Stack>
    </Frame>
  )
}
